import PreviousButton from "components/Previous/PreviousButton"

export const SECTION_TITLE_STYLE: React.CSSProperties = {
  display: "inline-block",
  color: "#211452",
  textAlign: "center",
  fontFamily: "Now",
  fontSize: "48px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "40px",
  whiteSpace: "nowrap",
  margin: "0 auto",
}

export interface SectionHeaderProps {
  onBack: () => void
  title: string | JSX.Element
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ onBack, title }) => (
  <>
    <div style={{ position: "absolute", top: 25, left: 25, display: "flex", alignItems: "center" }}>
      <PreviousButton onClick={onBack} style={{ position: "static" }} />
    </div>
    <div style={{ marginTop: 60, paddingBottom: 45, textAlign: "center" }}>
      <span style={SECTION_TITLE_STYLE}>{title}</span>
    </div>
  </>
)
